import { px, rect, aRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Part } from '../../types';

export const engines: Record<string, Part> = {
  engine_single: {
    id: 'engine_single',
    category: 'engine',
    name: 'Single',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 4, p.detailDark); aRect(ctx, a.x, a.y, 2, 1, p.detail); px(ctx, a.x - 1, a.y + 1, p.detailLight); },
  },
  engine_twin: {
    id: 'engine_twin',
    category: 'engine',
    name: 'Twin',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { rect(ctx, a.x - 2, a.y, 1, 4, p.detailDark); rect(ctx, a.x + 1, a.y, 1, 4, p.detailDark); px(ctx, a.x - 2, a.y, p.detail); px(ctx, a.x + 1, a.y, p.detail); },
  },
  engine_bell: {
    id: 'engine_bell',
    category: 'engine',
    name: 'Bell',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.detail); aRect(ctx, a.x, a.y + 1, 4, 3, p.detailDark); rect(ctx, a.x - 2, a.y + 1, 1, 3, p.detail); px(ctx, a.x + 1, a.y + 1, p.detailLight); },
  },
  engine_triple: {
    id: 'engine_triple',
    category: 'engine',
    name: 'Triple',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { rect(ctx, a.x - 3, a.y + 1, 1, 3, p.detailDark); aRect(ctx, a.x, a.y, 2, 4, p.detailDark); rect(ctx, a.x + 2, a.y + 1, 1, 3, p.detailDark); aRect(ctx, a.x, a.y, 2, 1, p.detail); px(ctx, a.x - 3, a.y + 1, p.detail); px(ctx, a.x + 2, a.y + 1, p.detail); },
  },
  engine_ring: {
    id: 'engine_ring',
    category: 'engine',
    name: 'Ring',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 4, 1, p.detailDark); rect(ctx, a.x - 2, a.y + 1, 1, 2, p.detailDark); rect(ctx, a.x + 1, a.y + 1, 1, 2, p.detailDark); aRect(ctx, a.x, a.y + 3, 4, 1, p.detailDark); aRect(ctx, a.x, a.y + 1, 2, 2, p.accent); },
  },
  engine_box: {
    id: 'engine_box',
    category: 'engine',
    name: 'Box',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 4, 4, p.detailDark); aRect(ctx, a.x, a.y, 4, 1, p.detail); rect(ctx, a.x - 2, a.y, 1, 4, p.detail); rect(ctx, a.x + 1, a.y, 1, 4, p.detailLight); aRect(ctx, a.x, a.y + 3, 4, 1, p.dark); aRect(ctx, a.x, a.y + 1, 2, 2, p.accent); },
  },
  engine_pulse: {
    id: 'engine_pulse',
    category: 'engine',
    name: 'Pulse',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.detail); aRect(ctx, a.x, a.y + 1, 2, 1, p.accent); aRect(ctx, a.x, a.y + 2, 2, 1, p.detailDark); aRect(ctx, a.x, a.y + 3, 2, 1, p.accent); aRect(ctx, a.x, a.y + 4, 2, 1, p.detailDark); },
  },
  engine_cluster: {
    id: 'engine_cluster',
    category: 'engine',
    name: 'Cluster',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 5 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 5 },
    },
    draw: (ctx, a, p) => { rect(ctx, a.x - 3, a.y + 1, 1, 4, p.detailDark); aRect(ctx, a.x, a.y, 2, 5, p.detailDark); rect(ctx, a.x + 2, a.y + 1, 1, 4, p.detailDark); px(ctx, a.x - 3, a.y + 1, p.detail); aRect(ctx, a.x, a.y, 2, 1, p.detail); px(ctx, a.x + 2, a.y + 1, p.detail); rect(ctx, a.x - 3, a.y + 3, 6, 1, p.detail); },
  },
  engine_nacelle: {
    id: 'engine_nacelle',
    category: 'engine',
    name: 'Nacelle',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 4 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 4 },
    },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.detail); aRect(ctx, a.x, a.y + 1, 4, 1, p.detailDark); aRect(ctx, a.x, a.y + 2, 4, 2, p.detailDark); aRect(ctx, a.x, a.y + 2, 2, 1, p.detailLight); aRect(ctx, a.x, a.y + 3, 4, 1, p.dark); },
  },
  engine_afterburner: {
    id: 'engine_afterburner',
    category: 'engine',
    name: 'Afterburner',
    requires: 'engine_pair',
    provides: {
      [SLOT.EXHAUST_L]: { baseSlot: SLOT.ENGINE_L, offsetY: 6 },
      [SLOT.EXHAUST_R]: { baseSlot: SLOT.ENGINE_R, offsetY: 6 },
    },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 4, 1, p.detailDark); aRect(ctx, a.x, a.y + 1, 2, 5, p.detailDark); aRect(ctx, a.x, a.y + 1, 2, 1, p.detail); aRect(ctx, a.x, a.y + 3, 2, 1, p.accent); aRect(ctx, a.x, a.y + 5, 4, 1, p.dark); },
  },
};
